import React, { Component } from "react";
import {
  Col,
  Row,
  Button,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  UncontrolledDropdown,
  Label,
  Input,
} from "reactstrap";
import SearchBox from "./SearchBox";
import style from "./Toolbar.module.scss";
import { debounce } from "../../../utils/Helper";
import Responsive from "react-responsive";
import AdvancedSearchbox from "../../AdvancedSearchbox/AdvancedSearchbox";
import Filter from "../../Modal/Order/Field/Symbol/Options/Filter";

class Toolbar extends Component {
  state = {
    filters: {
      text: "",
      status: this.props.parameterPending == true ? "Pending" : 0,
      type: 0,
      fromDate: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split("T")[0],
      toDate: new Date().toISOString().split("T")[0],
      todayOffers: false,
      todayOrdersToProcess: false,
    },
    advanced: {
      open: false,
    },
    statusChangePending: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.parameterPending !== this.props.parameterPending && !this.state.statusChangePending) {
      this.setState({
        filters: {
          ...this.state.filters,
          status: this.props.parameterPending ? "Pending" : 0,
        },
      });
    }
  }

  handleFilterDebounced = debounce(() => {
    this.props.changeFilter({
      ...this.state.filters,
    });
  }, 200);

  changeFilterValue = (props) => {
    this.setState(
      {
        filters: {
          ...this.state.filters,
          ...props,
        },
        statusChangePending: props.status !== undefined ? true : this.state.statusChangePending,
      },
      () => {
        this.handleFilterDebounced();
      }
    );
  };

  changeAdvancedFilter = (filter) => {
    if (filter.fromDate !== undefined || filter.toDate !== undefined) {
      this.props.changeAdvancedFilter(filter);
    }
  };

  handleCheckboxChange = (filterName, checked) => {
    const newFilters = { ...this.state.filters };
    if (filterName === 'todayOffers') {
      newFilters.todayOffers = checked;
      if (checked) newFilters.todayOrdersToProcess = false;
    } else if (filterName === 'todayOrdersToProcess') {
      newFilters.todayOrdersToProcess = checked;
      if (checked) newFilters.todayOffers = false;
    }
    this.setState({ filters: newFilters }, () => {
      this.handleFilterDebounced();
    });
    // Llamar a los props correspondientes
    if (filterName === 'todayOffers') {
      this.props.changeTodayOffersFilter({ value: checked });
    } else {
      this.props.changeTodayOrdersToProcess({ value: checked });
    }
  };

  render() {
    const { filters } = this.state;
    const { counters } = this.props;

    return (
      <div className={style.toolbar}>
        <Row>
          <Col md={0} lg={2} xl={1}>
            {/* Totals */}
            <Counter {...counters} />
          </Col>
          <Col md={5} xl={6} lg={4}>
            {/* Search input and Advanced */}
            <div>
              <AdvancedSearchbox
                searchboxPlaceholder="Search something"
                onBasicFilterUpdate={this.changeFilterValue}
                onAdvancedFilterUpdate={this.changeAdvancedFilter}
                defaultFromDate={filters.fromDate}
                defaultToDate={filters.toDate}
                showAdvanced
              />
            </div>
          </Col>

          <Row className="justify-content-between">
            <Col md={3} xl={3} lg={3} className={style.filterDropdown}>
              <DropDownFilterStatus value={filters.status} onChange={this.changeFilterValue} />
            </Col>
            <Col md={3} xl={3} lg={3} className={style.filterDropdown}>
              <Label
                className="switch switch-text switch-pill switch-secondary switch-lg"
                style={{ marginBottom: "0px", marginLeft: "50px" }}
              >
                <Input
                  type="checkbox"
                  className="switch-input"
                  onChange={(e) => this.handleCheckboxChange('todayOffers', e.target.checked)}
                  checked={this.state.filters.todayOffers}
                />
                <span className="switch-label" data-on="Day" data-off="All"></span>
                <span className="switch-handle"></span>
                <Label className="w-100 d-inline-block" style={{ minWidth: 120 }}>
                  Filter Offers
                </Label>
              </Label>
            </Col>

            <Col md={4} xl={4} lg={3} className={style.filterDropdown} style={{marginLeft: "10px"}}>
            <Label
                className="switch switch-text switch-pill switch-secondary switch-lg"
                style={{ marginBottom: "0px"}}
              >
                <Input
                  type="checkbox"
                  className="switch-input"
                  onChange={(e) => this.handleCheckboxChange('todayOrdersToProcess', e.target.checked)}
                  checked={this.state.filters.todayOrdersToProcess}
                />
                <span className="switch-label" data-on="Day" data-off="All"></span>
                <span className="switch-handle"></span>
                <Label className="w-150 d-inline-block" style={{ minWidth: 120 }}>
                  Orders to process
                </Label>
              </Label>
            </Col>
          </Row>

          <Col xl={2} md={3} className={style.export}>
            <Button color="primary" onClick={this.props.handleDownload}>
              <i className="fa fa-download"></i>
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

const Desktop = (props) => <Responsive {...props} minWidth={1000} />;

const Counter = ({ total, filtered }) => (
  <Desktop>
    <h6 className={"h6 page-title " + style.totals}>Records: {total}</h6>

    <div className="text-muted page-desc">{filtered} filtered</div>
  </Desktop>
);

const DropDownFilterStatus = ({ value, onChange }) => (
  <UncontrolledDropdown style={{ width: "100%" }}>
    <DropdownToggle caret color="secondary" className={style.dropdown}>
      {value !== 0 ? value : "All status"}
    </DropdownToggle>
    <DropdownMenu>
      <DropdownItem onClick={() => onChange({ status: 0 })}>{"All status"}</DropdownItem>
      <DropdownItem onClick={() => onChange({ status: "Pending" })}>{"Pending"}</DropdownItem>
      <DropdownItem onClick={() => onChange({ status: "Waiting" })}>{"Waiting"}</DropdownItem>
      <DropdownItem onClick={() => onChange({ status: "Authorized" })}>{"Authorized"}</DropdownItem>
      <DropdownItem onClick={() => onChange({ status: "Rejected" })}>{"Rejected"}</DropdownItem>
    </DropdownMenu>
  </UncontrolledDropdown>
);

export default Toolbar;
